import { BindingEngine } from 'aurelia-framework';
import { FieldModel, Modifiable } from '~/models/form-model';
import { ObjectUtils } from '~/utils/utils';

export class RestoreDialogUtils {
	public static addEventHandlers(
		bindingEngine: BindingEngine,
		fieldModel: { [key in Extract<string, string>]: FieldModel },
	): void {
		bindingEngine
			.propertyObserver(fieldModel.BSc_Reverse_Tran, 'value')
			.subscribe((newValue: string, oldValue: string) => {
				const isReverseTransactions = newValue === 'Y';
				// need to clone fieldModel because change handler does not fire when directly modifying visible property
				const effectiveDate = ObjectUtils.JSONClone(
					fieldModel.BSd_Reverse,
				);
				effectiveDate.visible = isReverseTransactions;
				effectiveDate.excludeFromSave = !isReverseTransactions;
				effectiveDate.modifiable = isReverseTransactions
					? Modifiable.TRUE
					: Modifiable.FALSE;
				fieldModel.BSd_Reverse = effectiveDate;
				const interestDate = ObjectUtils.JSONClone(
					fieldModel.BSd_Reverse_Interest,
				);
				interestDate.visible = isReverseTransactions;
				interestDate.excludeFromSave = !isReverseTransactions;
				interestDate.modifiable = isReverseTransactions
					? Modifiable.TRUE
					: Modifiable.FALSE;
				fieldModel.BSd_Reverse_Interest = interestDate;
			});
	}
}
